<template>
  <check-box-list-field v-if="computedReadOnly" :content="content" class="readonly el-input__inner" :data-id="`${name}-datalist`"/>
  <el-select
    v-else
    ref="infinite-dropdown"
    v-model="value"
    :id="`${fieldId}-${name}-datalist`"
    :class="[{ invalid: isInvalid }, 'stretch']"
    :data-id="`${name}-datalist`"
    :name="name"
    :clearable="clearable"
    :collapse-tags="!isFormControl"
    :multiple="multiple"
    :no-data-text="noDataText"
    :no-match-text="noDataText"
    :placeholder="placeholder"
    filterable
    remote
    :remote-method="filterOptions"
    @visible-change="onVisibleChange"
  >
    <el-option v-for="{ key, value } in filteredOptions" :key="key" :label="value" :data-id="`${name}-option--${key}`" :value="key" />
    <loader class="h-25" v-if="optionLoader" />
  </el-select>
</template>

<script>
import dropdownMixin from '../../../utils/mixin-dropdown'
import CheckBoxListField from '../../list-new/field-types/CheckBoxListField.vue'
import Loader from '../../Loader.vue'

export default {
  name: 'MultiSelect',
  components: {
    Loader,
    CheckBoxListField,
  },
  mixins: [dropdownMixin],
  computed: {
    content() {
      const value = !Array.isArray(this.value) ? [] : this.value
      if (this.dropdownHasValue) {
        let stringValues = value.map((key) => String(key))
        const items = this.options.filter((option) => stringValues.includes(String(option.key)))
        return items.map((item) => item.value).join(', ')
      }
      return ''
    },
  },
}
</script>
